<template>
    <div style="margin: 50px 0">
        <v-row class="mypage-contents__head">
            <v-col cols="auto" class="mypage-contents__title"> 신청내역 </v-col>
            <v-spacer />
            <v-col v-show="false" cols="auto">
                <v-btn v-if="disabled" outlined :color="disabled ? 'primary' : 'gray'" @click="disabled = !disabled">수정하기</v-btn>
            </v-col>
        </v-row>
        <v-card flat>
            <div role="table" class="board-table board-table--input">
                <view-application-support v-model="applicant" :files="files" :program="program" @files="syncFiles" />
            </div>
        </v-card>

        <v-row v-if="!disabled" class="mt-4">
            <v-spacer />
            <v-col cols="auto">
                <v-btn outlined color="gray" @click="reset">취소</v-btn>
                <v-btn color="primary" class="ml-2">수정</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import api from "@/api";

import ViewApplicationSupport from "./view-application-support.vue";
import ViewApplicationEducation from "./view-application-education.vue";

export default {
    components: {
        ViewApplicationSupport,
        ViewApplicationEducation,
    },
    props: ["application"],
    computed: {
        program() {
            return this.application.program;
        },
    },
    data() {
        return {
            disabled: true,
            applicant: null,
            files: [],
        };
    },
    methods: {
        async sync() {
            this.applicant = this.application.applicant;
            this.files = this.application.files;
        },
        syncFiles(files) {
            this.files = files;
        },

        reset() {
            this.disabled = !this.disabled;
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
